export enum UserLoginTypes {
	CREDENTIALS = "CREDENTIALS",
	GOOGLE = "GOOGLE",
	FACEBOOK = "FACEBOOK",
	TWITTER = "TWITTER",
}
